
import { BlogSection } from '@/types/blog';

export const quellenSection: BlogSection = {
  id: 'quellen',
  title: 'Quellen',
  content: `
    <div class="text-sm text-joerg-600 border-t border-joerg-200 pt-4 mt-8">
      <p class="mb-2">Dunn, E. W., Gilbert, D. T., & Wilson, T. D. (2011). If money doesn't make you happy, then you probably aren't spending it right. <em>Journal of Consumer Psychology, 21(2)</em>, 115-125.</p>
      
      <p class="mb-2">Knutson, B., & Kuhnen, C. M. (2005). The neural basis of financial risk taking. <em>Neuron, 47(5)</em>, 763-770.</p>
      
      <p class="mb-2">Loewenstein, G., Weber, E. U., Hsee, C. K., & Welch, N. (2001). Risk as feelings. <em>Psychological Bulletin, 127(2)</em>, 267-286.</p>
      
      <p class="mb-2">McClure, S. M., Laibson, D. I., Loewenstein, G., & Cohen, J. D. (2004). Separate neural systems value immediate and delayed monetary rewards. <em>Science, 306(5695)</em>, 503-507.</p>
      
      <p class="mb-2">Prelec, D., & Loewenstein, G. (1998). The red and the black: Mental accounting of savings and debt. <em>Marketing Science, 17(1)</em>, 4-28.</p>
      
      <p class="mb-2">Rick, S., Cryder, C. E., & Loewenstein, G. (2008). Tightwads and spendthrifts. <em>Journal of Consumer Research, 34(6)</em>, 767-782.</p>
      
      <p class="mb-2">Shafir, E., Diamond, P., & Tversky, A. (2013). Money illusion. <em>Quarterly Journal of Economics, 112(2)</em>, 341-374.</p>
      
      <p>Sharot, T., Riccardi, A. M., Raio, C. M., & Phelps, E. A. (2007). Neural mechanisms mediating optimism bias. <em>Nature, 450(7166)</em>, 102-105.</p>
    </div>
  `
};
